import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import {
  EditIcon,
  LoadingIcon,
  MoreIcon,
  NoDisplayIcon,
  SyncIcon,
  TrashIcon,
} from '~components/ui/icons';
import { PlaylistDetail_PlaylistFragment } from './__generated__/PlaylistDetail.graphql';

type Props = {
  playlist: PlaylistDetail_PlaylistFragment;
  onRename: () => void;
  onSync: () => void;
  onRemoveDisplays: () => void;
  onDelete: () => void;
};

export function PlaylistDetailMoreActions({
  playlist,
  onRename,
  onSync,
  onRemoveDisplays,
  onDelete,
}: Props) {
  const hasDisplays = playlist.syncedDisplays.length > 0;
  const hasOutOfSyncDisplays = playlist.outOfSyncDisplays.length > 0;
  const isSyncing = playlist.syncingDisplays.length > 0;
  const isRemoving = playlist.removingDisplays.length > 0;
  const isUpdating = isSyncing || isRemoving;

  return (
    <Menu>
      <MenuButton as={Button} aria-label="Options" variant="outline">
        <MoreIcon />
      </MenuButton>
      <MenuList>
        <MenuItem icon={<EditIcon />} onClick={onRename} isDisabled={isUpdating}>
          Rename
        </MenuItem>
        <MenuItem
          icon={isSyncing ? <LoadingIcon /> : <SyncIcon />}
          isDisabled={isUpdating || !hasOutOfSyncDisplays}
          onClick={onSync}
        >
          Sync
        </MenuItem>
        <MenuItem
          icon={isRemoving ? <LoadingIcon /> : <NoDisplayIcon />}
          isDisabled={isUpdating || !hasDisplays}
          onClick={onRemoveDisplays}
        >
          Remove from displays
        </MenuItem>
        <MenuItem
          icon={<TrashIcon color="red.500" />}
          color={'red.500'}
          isDisabled={isUpdating}
          onClick={onDelete}
        >
          Delete
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
